<template>
  <div class="row jipvio-dashboard">
    <div class="col-12">
      <card class="mt-70" card-body-classes="table-full-width" no-footer-line>
        <h4 class="card-title ml-20">문의내역</h4>
        <div
          class="d-flex justify-content-center justify-content-sm-between flex-wrap mt-80"
        >
          <el-select
            class="select-primary mb-3 ml-20"
            style="width: 200px"
            v-model="pagination.perPage"
            placeholder="Per page"
          >
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>

          <fg-input class="mr-30">
            <el-popover
              class="fl mr-10"
              placement="bottom-start"
              width="70"
              trigger="click"
            >
              <el-checkbox
                v-for="tc in tableColumns"
                :key="tc.label"
                :label="tc.label"
                v-model="tc.vif"
              ></el-checkbox>

              <el-button class="pr-2 pl-2" slot="reference"
                >필터 <i class="fas fa-angle-down"></i
              ></el-button>
            </el-popover>

            <el-select
              class="select-primary mb-3 fl mr-10"
              style="width: 200px"
              v-model="searchStd"
              placeholder="검색기준"
              @input="searchSetData(searchStd)"
            >
              <el-option
                class="select-default"
                v-for="tc in tableColumns"
                :key="tc.label"
                :label="tc.label"
                :value="tc.label"
              >
              </el-option>
            </el-select>
            <el-autocomplete
              type="search"
              class="mb-3 fl"
              clearable
              style="width: 200px"
              placeholder="Search records"
              v-model="searchQuery"
              aria-controls="datatables"
              :fetch-suggestions="querySearchAsync"
              @select="handleSelect"
            >
            </el-autocomplete>
          </fg-input>
        </div>
        <el-table stripe class="col-10 mt-10" :data="tableData">
          <el-table-column
            v-for="column in filteredColumns()"
            :key="column.label"
            :min-width="column.minWidth"
            :prop="column.prop"
            :label="column.label"
            align="center"
            :sortable="column.sortable"
          >
          </el-table-column>

          <el-table-column
            :min-width="135"
            fixed="right"
            label="작업"
            align="center"
          >
            <template v-slot="props">
              <div class="table-actions">
                <n-button
                  @click.native="handleLike(props.$index, props.row)"
                  class="like"
                  type="info"
                  size="sm"
                  round
                  icon
                >
                  <i class="far fa-comments"></i>
                </n-button>
                <n-button
                  @click.native="editQst()"
                  class="edit"
                  type="warning"
                  size="sm"
                  round
                  icon
                >
                  <i class="jipvio-ui-icons-pen"></i>
                </n-button>
                <n-button
                  @click.native="printData(props.$index, props.row)"
                  class="remove"
                  type="danger"
                  size="sm"
                  round
                  icon
                >
                  <i class="fa fa-times"></i>
                </n-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <n-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.totalCnt"
          >
          </n-pagination>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Select,
  Option,
  Input,
  Button,
  Popover,
  Checkbox,
  CheckboxGroup,
  Autocomplete
} from "element-ui";
import { Pagination as NPagination } from "@/components";
import { Button as NButton } from "@/components";
import card from "@/components/Cards/Card.vue";
import propApi from "@/service/property";
import Swal from "sweetalert2";

import { createNamespacedHelpers } from "vuex";

const {
  mapGetters: sessionMapGetters,
  mapActions: sessionMapActions
} = createNamespacedHelpers("loginSession");

export default {
  components: {
    NPagination,
    NButton,
    card,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Input.name]: Input,
    [Button.name]: Button,
    [Popover.name]: Popover,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Autocomplete.name]: Autocomplete
  },
  created() {
    console.log("======문의내역 created");
    // console.log(this.sessionUserInfo);
    // if (this.sessionUserInfo.type == "LO") {
    //   //실제로는 임대인 param 넘겨서 정보 불러오기
    //   this.getAllProperty();
    // } else if (this.sessionUserInfo.type == "AG") {
    //   //실제로는 공인중개사 param 넘겨서 정보 불러오기
    //   this.getAllProperty();
    // }
  },

  computed: {
    ...sessionMapGetters({
      sessionUserInfo: "getUserInfo"
    }),
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.totalCnt;
    }
  },
  data() {
    return {
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        totalCnt: 0,
        totalPages: 10
      },
      searchStd: null,
      searchQuery: "",
      selects: [],

      timeout: null,
      // API data
      paymentTypeCode: null, // 전세,월세
      bldTypeCode: null, // 건물 종류

      tableColumns: {
        CTT: {
          prop: "typeId",
          label: "거래형태",
          minWidth: 125,
          sortable: true,
          vif: true
        },
        purpsCd: {
          prop: "purpsCd",
          label: "종류",
          minWidth: 100,
          sortable: true,
          vif: true
        },
        bldNm: {
          prop: "addr",
          label: "건물명",
          minWidth: 110,
          sortable: true,
          vif: true
        },
        dong: {
          prop: "newAddr",
          label: "법정동",
          minWidth: 110,
          sortable: true,
          vif: true
        },
        JiBun: {
          prop: "newAddr",
          label: "지번",
          minWidth: 100,
          sortable: true,
          vif: true
        },
        area: {
          prop: "useArea",
          label: "면적",
          minWidth: 100,
          sortable: true,
          vif: true
        },
        deposit: {
          prop: "deposit",
          label: "보증금",
          minWidth: 110,
          sortable: true,
          vif: true
        },
        monthlyPay: {
          prop: "payment",
          label: "월세",
          minWidth: 100,
          sortable: true,
          vif: true
        },
        updatedDate: {
          prop: "updatedDate",
          label: "등록일",
          minWidth: 110,
          sortable: true,
          vif: true
        },
        qstTitle: {
          prop: "qstTitle",
          label: "제목",
          minWidth: 110,
          sortable: true,
          vif: true
        },
        answState: {
          prop: "answState",
          label: "답변상태",
          minWidth: 125,
          sortable: true,
          vif: true
        }
      },
      sor: false,
      tableData: [
        {
          typeId: "전세",
          purpsCd: "아파트",
          addr: "황금캐슬",
          newAddr: "황금캐슬 102동 601호",
          useArea: 28.56,
          deposit: 258000000,
          payment: 333333,
          updatedDate: "20.02.02",
          qstTitle: "황금캐슬",
          answState: "답변 완료"
        },
        {
          typeId: "월세",
          purpsCd: "원룸",
          addr: "푸르지오",
          newAddr: "푸르지오 102동 601호",
          useArea: 28.56,
          deposit: 200000000,
          payment: 333333,
          updatedDate: "20.03.03",
          qstTitle: "푸르지오",
          answState: "미답변"
        },
        {
          typeId: "전세",
          purpsCd: "아파트",
          addr: "자이",
          newAddr: "자이 102동 601호",
          useArea: 28.56,
          deposit: 233000000,
          payment: 333333,
          updatedDate: "20.04.04",
          qstTitle: "자이",
          answState: "미답변"
        }
      ]
    };
  },
  methods: {
    searchSetData(value) {
      this.searchQuery = "";
      let selectData = [];
      if (value == "거래형태") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          // selectData.push(ele.paymentType);
          selectData.push(ele.typeId);
        });
      } else if (value == "종류") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          // selectData.push({ value: ele.type });
          selectData.push(ele.purpsCd);
        });
      } else if (value == "건물명") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.addr);
        });
      } else if (value == "법정동") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.newAddr);
        });
      } else if (value == "지번") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.newAddr);
        });
      } else if (value == "면적") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.useArea);
        });
      } else if (value == "보증금") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(String(ele.deposit));
        });
      } else if (value == "월세") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(String(ele.payment));
        });
      } else if (value == "등록일") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.updatedDate);
        });
      } else if (value == "제목") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.qstTitle);
        });
      } else if (value == "답변상태") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.answState);
        });
      }

      /* 중복 확인 및 제거 */
      selectData = Array.from(new Set(selectData));

      /* value값으로 만들어 주지 않으면 읽지 못함 */
      if (selectData.length > 0) {
        let values = [];
        for (let i = 0; i < selectData.length; i++) {
          values.push({
            label: value,
            value: selectData[i]
          });
        }
        this.selects = values;
      }
      console.log("=======================this.searchData");
      console.log(this.selects);
    },

    querySearchAsync(queryString, cb) {
      let searchResult = this.selects;

      let results = queryString
        ? searchResult.filter(this.createFilter(queryString))
        : searchResult;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 300);
    },
    createFilter(queryString) {
      return el => {
        return el.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect(item) {
      console.log("=================handleSelect");
      if (this.searchStd == "거래형태") {
        this.paymentTypeCode = item.value;
      } else if (this.searchStd == "종류") {
        this.bldTypeCode = item.value;
      }
      // this.getAllProperty();
    },

    printData(index, row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      console.log("here");
      console.log(index);
      console.log(row);
      console.log(indexToDelete);
      // if (indexToDelete >= 0) {
      //   this.tableData.splice(index, 1);
      // }
    },

    editQst() {
      this.$router.push({
        path: "/mypage/qst/register"
        // query: { x: this.x, y: this.y }
      });
    },

    handleLike(index, row) {
      Swal.fire({
        title: `You liked ${row.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "btn btn-success btn-fill"
      });
    },
    handleEdit(index, row) {
      Swal.fire({
        title: `You want to edit ${row.name}`,
        buttonsStyling: false,
        confirmButtonClass: "btn btn-info btn-fill"
      });
    },
    handleDelete(index, row) {
      Swal.fire({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteRow(row);
          Swal.fire({
            title: "Deleted!",
            text: `You deleted ${row.name}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },

    applyCommonCode() {
      //PTT========================================================
      this.sessionCoCodeMap.PTT.forEach((ele, dex) => {
        this.selects.PTTMap[ele.code] = ele.name;
      });

      //BPP========================================================
      this.sessionCoCodeMap.BPP.forEach((ele, dex) => {
        this.selects.BPPMap[ele.code] = ele.name;
      });
    },
    formatMoney(money) {
      const moneyVal = money < 0 ? false : money;
      const unitWords = ["원", "만원", "억", "조", "경"];
      const splitUnit = 10000;
      const splitCount = unitWords.length;
      let resultArray = [];
      let resultString = "";

      for (var i = 0; i < splitCount; i++) {
        var unitResult =
          (moneyVal % Math.pow(splitUnit, i + 1)) / Math.pow(splitUnit, i);
        unitResult = Math.floor(unitResult);
        if (unitResult > 0) {
          resultArray[i] = unitResult;
        }
      }
      for (var i = 0; i < resultArray.length; i++) {
        if (!resultArray[i]) continue;
        resultString = String(resultArray[i]) + unitWords[i] + resultString;
      }

      return resultString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    async getAllProperty() {
      const pagingReq = {
        pageNo: this.pagination.currentPage - 1,
        sizePerPage: this.pagination.perPage,
        swLat: 37.66258399481432,
        swLng: 127.04401962842194,
        neLat: 37.66762719185185,
        neLng: 127.04979178950516,
        typeList: this.bldTypeCode
      };

      const res = await propApi.getAllProperty(pagingReq);

      this.pagination.perPage = res.pagingInfo.size;
      this.pagination.currentPage = res.pagingInfo.pageNo + 1;
      this.pagination.totalCnt = res.pagingInfo.totalCnt;
      this.pagination.totalPages = res.pagingInfo.totalPages;
      this.tableData = res.payload;
      console.log(this.tableData);

      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].formattedMDT = this.$moment(
          this.tableData[i].moveDt
        ).format("YYYY-MM-DD");

        this.tableData[i].formattedPTT = this.selects.PTTMap[
          this.tableData[i].paymentType
        ];
        this.tableData[i].formattedType = this.selects.BPPMap[
          this.tableData[i].type
        ];

        this.tableData[i].formattedDeposit = this.formatMoney(
          this.tableData[i].deposit
        );

        this.tableData[i].formattedPayment = this.formatMoney(
          this.tableData[i].payment
        );

        this.tableData[i].formattedUDT = this.$moment(
          this.tableData[i].updatedDate
        ).format("YYYY-MM-DD");
      }

      console.log(this.tableData);
    },

    filteredColumns() {
      const newTbColumns = _.cloneDeep(this.tableColumns);
      for (let key in newTbColumns) {
        if (newTbColumns[key].vif == false) {
          delete newTbColumns[key];
        }
      }
      console.log(newTbColumns);
      return newTbColumns;
    }
  },
  mounted() {}
  // watch: {
  //   "pagination.currentPage"(newValue, oldValue) {
  //     this.getAllProperty();
  //   },
  //   "pagination.perPage"(newValue, oldValue) {
  //     this.pagination.currentPage = 1;
  //     this.getAllProperty();
  //   }
  // }
};
</script>
<style></style>
